import { Box, styled } from '@mui/material';

import { SizingMultiplier } from '../../sizing-multiplier.constant';

export const Note = styled(Box)(({ theme }) => ({
  background: theme.palette.background.box,
  padding: theme.spacing(SizingMultiplier.md),
  borderRadius: 8,
}));
